import React from "react";

const CameraSolutions = () => {
  return (
    <div className="">
      {/* <div className="min-h-screen relative top-28"> */}
      CameraSolutions
    </div>
  );
};

export default CameraSolutions;
